import { render, staticRenderFns } from "./mdInfoCard.vue?vue&type=template&id=449c849c&scoped=true&"
import script from "./mdInfoCard.vue?vue&type=script&lang=js&"
export * from "./mdInfoCard.vue?vue&type=script&lang=js&"
import style0 from "./mdInfoCard.vue?vue&type=style&index=0&id=449c849c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "449c849c",
  null
  
)

export default component.exports